export const getRoleSeparation = (roleName: string): string => {
  switch (roleName) {
    case 'RegisteredUser':
      return 'Registered User';
    case 'LandscapeInitiativeManager':
      return 'Initiative Manager';
    case 'ConvenerManager':
      return 'Convener Manager';
    case 'BuyerManager':
      return 'Buyer Manager';
    case 'ConsortiumManager':
      return 'Consortium Manager';
    default:
      return roleName;
  }
};
